import React  from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import NavBar from "../NavBar/NavBar";
import SampleItemImages from "../SampleItemImages/SampleItemImages";
import CanonicalImages from "../CanonicalImages/CanonicalImages";
import "src/styles/App.css";

/**
 * This container is used for the high level layout components on the page.
 * This includes: Navbar
 *                SampleItemImages
 *                CanonicalImages
 */
const App: React.FunctionComponent = () => {

    return (
        <>
            <NavBar />
            <Switch>
                <Route exact path="/">
                    <Redirect to="/sampleItemImages" />
                </Route>
                <Route path="/sampleItemImages">
                    <SampleItemImages />
                </Route>
                <Route path="/canonicalImages">
                    <CanonicalImages />
                </Route>
                <Route path="*" >
                    <Redirect to="/sampleItemImages" />
                </Route>
            </Switch>
        </>
    );
};

export default App;